<template>
  <div>
    <validation-observer ref="transferNumbersForm">
      <b-card title="Rufnummernmitnahme/Rufnummernportierung"
              v-if="CHECKOUT_DATA.phoneline.option == 2 || CHECKOUT_DATA.phoneline.option == 3">
        <b-form-checkbox
            class="mb-1"
            v-model="CHECKOUT_DATA.transfer_phonenumer"
        >
          Ja, ich bitte um die Übernahme meiner bisherigen Rufnummer/n.
        </b-form-checkbox>


        <div v-if="CHECKOUT_DATA.transfer_phonenumer">
          <b-row>
            <b-col md="6">
              <b-form-group label="Vorname" label-for="phoneline-new-firstname" class="required|max:30">
                <validation-provider
                    #default="{ errors }"
                    name="Vorname"
                    rules="required"
                    vid="phoneline-firstname"
                >
                  <b-form-input
                      id="phoneline-new-firstname"
                      v-model="CHECKOUT_DATA.phoneline.firstname"
                      placeholder="Bitte geben Sie den Vornamen an."
                  />
                  <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Name" label-for="phoneline-new-name" class="required">
                <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required|max:30"
                    vid="phoneline-name"
                >
                  <b-form-input
                      id="phoneline-new-name"
                      v-model="CHECKOUT_DATA.phoneline.name"
                      placeholder="Bitte geben Sie den Namen an."
                  />
                  <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button variant="primary" size="sm" @click="copyAdressData">Personendaten von VertragspartnerIn übernehmen
          </b-button>

          <div class="mt-2 mb-1">
            <strong>Mitzunehmende Rufnummer/n:</strong>
          </div>
          <div v-for="index in (CHECKOUT_DATA.countVoiceChannels*2 + 2)" :key="index">
            <b-form-group
                :label="'Rufnummer '+index+' mit Vorwahl'"
                :label-for="'phoneline-takeover-provider'+index"
                :class="{'d-none': index > 2 && (!CHECKOUT_DATA.show_more_numbers || !hasAdditionalPhonelines)}"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Rufnummer"
                  :rules="{required:index === 1}"
                  :vid="'phoneline-takeover-provider'+index"
              >
                <b-form-input
                    id="phoneline-new-name"
                    v-model="CHECKOUT_DATA.phoneline.numbers[index]"
                    placeholder="Bitte geben Sie die Rufnummer mit Vorwahl  an."
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <div v-if="index == 2 && !hasAdditionalPhonelines" class="p-1 bg-light mb-1">
              <p class="font-weight-bolder mb-0">Wichtiger Hinweis:</p>
              In diesem Tarif ist ein Sprachkanal mit 2 Rufnummern inklusive.<br/>
              Wenn Sie weitere Rufnummern übernehmen möchten, wählen Sie bitte die Zusatzoptionen "Zusätzlicher
              Sprachkanal" aus.
              Anschließend haben Sie hier die Möglichkeit weitere Rufnummern zu übernehmen.<br/>
              Klicken Sie bitte <b-link @click="goToPayTvSection">HIER</b-link> um zu den kostenpflichtigen Zusatzoptionen zugelangen und um ein zusätzlichen Sprachkanal zu buchen.
            </div>
            <div v-if="index == 2 && hasAdditionalPhonelines">
              <div v-if="index == 2 && hasAdditionalPhonelines" class="p-1 bg-light mb-1">
                In diesem Tarif ist ein Sprachkanal mit 2 Rufnummern inklusive.<br/>
                Sie haben zudem {{CHECKOUT_DATA.countVoiceChannels }} {{CHECKOUT_DATA.countVoiceChannels  == 1 ? 'Sprachkanal' : 'Sprachkanäle'}} als Option ausgewählt. Somit können Sie insgesamt {{CHECKOUT_DATA.countVoiceChannels*2+2}} Rufnummern übernehmen.
              </div>
              <b-form-checkbox
                  class="mb-1"
                  v-if="index == 2"
                  v-model="CHECKOUT_DATA.show_more_numbers"
              >
                Weitere zu übernehmende Rufnummern
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormRadioGroup,
  BFormRadio
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, required_if, email, digits} from '@validations'

export default {
  name: "PhoneNumberSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormRadioGroup,
    BFormRadio
  },
  data() {
    return {
      address: {},
      value: [],
      showMoreNumbers: false,
      transferNumbers: false,
      hasAdditionalPhonelines: false,
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'BILLING_ADDRESS']),
    computedAdditionalOptions: {
      get() {
        return this.CHECKOUT_DATA.additionalOptions
      }
    },
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.transferNumbersForm.validate()
    },
    /**
     * @returns {number}
     */
    minDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      // 15th two months prior
      const minDate = new Date(today)
      return minDate
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      const weekday = date.getDay()
      const day = date.getDate()
      const month = date.getMonth()

      let eastern = this.getEaster(date.getFullYear())
      let days = [-2, 0, 1, 39, 49, 50]

      let disableDay = false
      days.forEach(item => {
        let currentDate = new Date(eastern.getTime() + (item * 24 * 60 * 60 * 1000));
        if (currentDate.toDateString() == date.toDateString()) {
          disableDay = true
          return true
        }
      })

      return weekday === 0 || weekday === 6 ||
          (month === 11 && (day === 24 || day === 25 || day === 26 || day === 31)) ||
          (month === 9 && day === 3) || (month === 4 && day === 1) || disableDay
    },
    getEaster(year) {
      let f = Math.floor,
          // Golden Number - 1
          G = year % 19,
          C = f(year / 100),
          // related to Epact
          H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
          // number of days from 21 March to the Paschal full moon
          I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
          // weekday for the Paschal full moon
          J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
          // number of days from 21 March to the Sunday on or before the Paschal full moon
          L = I - J,
          month = 3 + f((L + 40) / 44),
          day = L + 28 - 31 * f(month / 4);

      let date = new Date(year, month - 1, day);

      return date;
    },
    copyAdressData() {
      this.CHECKOUT_DATA.phoneline.firstname = this.BILLING_ADDRESS.firstname
      this.CHECKOUT_DATA.phoneline.name = this.BILLING_ADDRESS.name
    },
    checkAdditionalPhonelines() {
      this.hasAdditionalPhonelines = false

      this.CHECKOUT_DATA.additionalOptions.forEach((serviceOptionItem) => {
        if (serviceOptionItem.description === 'Zusätzlicher Sprachkanal') {
          this.hasAdditionalPhonelines = true
        }
      })
    },
    goToPayTvSection() {
      setTimeout(function () {
        //scroll to the first error
        let yOffset = 0;
        let el = document.querySelector("#paytv-section")
        let y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
      }, 200);
    }
  },
  watch: {
    computedAdditionalOptions() {
      this.checkAdditionalPhonelines()
    }
  },
  mounted() {
    this.checkAdditionalPhonelines()
  }
}
</script>

<style scoped>

</style>
